// extracted by mini-css-extract-plugin
export default {"userDashboardWrapper":"FormSetting_userDashboardWrapper__cgD8N","userDashboard":"FormSetting_userDashboard__f+HAE","leftSide":"FormSetting_leftSide__n+hSY"};